import React from 'react'

import { FormValue } from '@/types'

import { AnyObject, FormInput } from './types'

export interface FormFieldContext<T = AnyObject> {
	disabled?: boolean
	id?: string,
	isCompact?: boolean,
	isFieldHighlighted?: boolean,
	isHorizontal?: boolean,
	isReadOnly?: boolean,
	loading?: boolean,
	name?: string,
	onBlur?: (e: React.FocusEvent) => void,
	onChange?: (value: FormValue) => void,
	onFocus?: (e: React.FocusEvent) => void,
	onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void,
	register?: (input: FormInput<T>) => void,
	required?: boolean,
	value?: FormValue,
	withQueryString?: boolean
}

export const FormFieldContext = React.createContext<FormFieldContext>(
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	null as any,
)

export const withFormField = <T extends object>(Component: T): T => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const CM = Component as any

	return class WithFormField extends React.Component {
		render() {
			return (
				<FormFieldContext.Consumer>
					{(context: FormFieldContext) => <CM {...context} {...this.props} />}
				</FormFieldContext.Consumer>
			)
		}
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} as any
}

FormFieldContext.displayName = 'FormFieldContext'
